import { render, staticRenderFns } from "./task-records.vue?vue&type=template&id=2539f374"
import script from "./task-records.vue?vue&type=script&lang=js"
export * from "./task-records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports